import { FC, useState } from 'react'

import { Card, Tab } from 'components'
import { useTabs } from 'hooks'
import { TabsProvider } from 'hooks/useTabs/provider'
import { SPACING } from 'utils'

import SearchTab from './components/tableConsultaJobs'
import { VisualizarJobs } from './components/visualizarJobs'

// const ConsultaJobs: FC = () => {
//   const tableData = [
//     {
//       jobs: 'Contratos Vigentes',
//       tipo: 'Mensal'
//     },
//     {
//       jobs: 'validação à Vencer Contraparte',
//       tipo: 'Mensal'
//     },
//     {
//       jobs: 'validação Pendente Contraparte',
//       tipo: 'Mensal'
//     }
//   ]
// }

const JobsConsultationComponent: React.FC = () => {
  const {
    tabs,
    selectedTab,
    handleChangeTab
  } = useTabs(['Pesquisar'])

  return (
    <>
      <Tab value={selectedTab.position} handleChange={handleChangeTab} tabs={tabs} />
      {selectedTab.position === 0 && <SearchTab />}
    </>
  )
}

  // const [tabs, setTabs] = useState<string[]>(['Pesquisar'])
  // const [selectedTab, setSelectedTab] = useState(0)
  // const handleChange = (_, newValue) => setSelectedTab(newValue)
  // const addNewTab = (tabName: string) => {
  //   if (tabs.length >= 2) {
  //     let tabSetados = [...tabs]
  //     tabSetados = tabSetados.filter((tab) => tab === 'Pesquisar')
  //     tabSetados.push(tabName)
  //     setTabs(tabSetados)
  //   } else {
  //     setTabs((prevTabs) => [...prevTabs, tabName])
  //   }
  //   setSelectedTab(1)

  // return (
  //   <>
  //     <Tab tabs={tabs} value={selectedTab} handleChange={handleChange} />
  //     {selectedTab === 0 && (
  //       <Card
  //         marginLeft={SPACING.spacing20}
  //         marginRight={SPACING.spacing20}
  //         marginBottom={SPACING.spacing100}
  //         padding={SPACING.spacing20}
  //         boxShadow={`0px -1px 32px rgba(50, 50, 71, 0.12), 0px 24px 32px rgba(50, 50, 71, 0.12)`}
  //         borderRadius={`0px 10px 0px 0px`}
  //       >
  //         <TableConsultaJobs addTab={addNewTab} tableData={tableData} />
  //       </Card>
  //     )}
  //     {selectedTab === 1 && (
  //       <Card
  //         marginLeft={SPACING.spacing20}
  //         marginRight={SPACING.spacing20}
  //         marginBottom={SPACING.spacing100}
  //         padding={SPACING.spacing20}
  //         boxShadow={`0px -1px 32px rgba(50, 50, 71, 0.12), 0px 24px 32px rgba(50, 50, 71, 0.12)`}
  //         borderRadius={`0px 10px 0px 0px`}
  //       >
  //         <VisualizarJobs />
  //       </Card>
  //     )}
  //   </>
  // )

const JobsConsultation: React.FC = () => {
  return (
    <TabsProvider>
      <JobsConsultationComponent />
    </TabsProvider>
  )
}
export default JobsConsultation
